import { Controller } from 'stimulus';

class CheckboxValidationController extends Controller {
  connect() {
    this.changeRequiredAttribute();
  }

  getCheckedCheckboxes() {
    return this.element.querySelectorAll('input[type="checkbox"]:checked').length;
  }

  onCheckboxChange() {
    this.changeRequiredAttribute();
  }

  changeRequiredAttribute() {
    const hasCheckedCheckbox = this.getCheckedCheckboxes() > 0;

    this.checkboxTargets.forEach((checkbox) => {
      checkbox[hasCheckedCheckbox ? 'removeAttribute' : 'setAttribute']('required', 'required');
    });
  }
}

CheckboxValidationController.targets = [
  'checkbox',
];

export default CheckboxValidationController;
